<template>
  <div class="wrap login-wrap">
    <div class="logo-wrap">
      <img src="@/assets/img/logo_beta.png" class="w-270px" alt="better and better" />
      <p>이메일 인증</p>
    </div>
    <div class="login-form">
      <div class="fail mb-40" v-if="isFail">
        <p class="txt-red">로그인 {{ failCount }}회 실패하였습니다.</p>
        <p>비밀번호를 재설정 해주시기 바랍니다.</p>
      </div>
      <ul>
        <li>
          <input type="text" placeholder="아이디(이메일)을 입력해 주세요." v-model="input.userId" @keyup.enter="check()" @keyup="keyupEvent" id="userId" />
        </li>
        <li>
          <input type="text" placeholder="과정코드를 입력하세요." v-model="input.courseAccesscode" @keyup.enter="check()" @keyup="keyupEvent" id="accessCode" />
          <!-- 인증된 메일일 경우 노출 -->
          <img v-if="isSuccess == 1" src="@/assets/img/login-check-ok.svg" alt="checked" class="check-img" />
          <!-- 인증되지 않은 메일일 경우 -->
          <img v-if="isSuccess == 2" src="@/assets/img/login-check-error.svg" alt="checked" class="check-img" />
        </li>
        <!-- 인증된 메일일 경우 노출 -->
        <p v-if="isSuccess == 1">인증된 메일입니다.</p>

        <!-- 인증된 메일일 경우 비밀번호 입력란 노출 -->
        <div v-if="isSuccess == 1">
          <li>
            <input type="password" placeholder="비밀번호를 입력해 주세요" v-model="input.password" @keyup.enter="login()" />
          </li>
          <!-- 비밀번호가 틀렸을 경우 -->
          <p class="txt-red" v-if="!isPassword">비밀번호를 다시 확인해 주세요.</p>
        </div>
      </ul>
      <div class="remember-id" v-if="isSuccess == 1">
        <input type="checkbox" name="autoLogin" id="" v-model="autoLogin" />
        <span>자동 로그인</span>
      </div>
    </div>

    <div class="bnb-btn">
      <!-- 기업코드 혹은 아이디 입력 시 class="active" 활성화 -->
      <div v-if="isSuccess == 0 || isSuccess == 2">
        <button @click="check()" :class="{ active: isActive }">계속하기</button>
      </div>
      <div v-if="isSuccess == 1">
        <!-- 기업코드와 아이디가 인증이 된 항목일 경우 로그인 버튼으로 바뀜 -->
        <button class="active" @click="login()">로그인</button>
        <p @click="passwordAcount()">비밀번호를 잊으셨나요?</p>
        <p v-if="isFail" @click="passwordAcount()">비밀번호 재설정 하러 가기</p>
      </div>
    </div>
  </div>
</template>
<script>
import { fcmSetting, receivedNotifcation } from "@/module/noti.js";
import { EmptyCheck, EmailFormatCheck } from "@/utils/validation";
import LogRocket from "logrocket";
export default {
  name: "login",
  data: () => ({
    sampleData: "abc",
    isAxiosRun: false,
    isSuccess: 0,
    isActive: false,
    isPassword: true,
    input: {
      courseAccesscode: "",
      userId: "",
      password: "",
    },
    loginErrMessage: ["기업코드를 재확인 해 주세요.", "사용 불가한 이메일입니다. 담당자에게 문의 부탁 드립니다.", "해당 과정은 종료한지 1년이 지나 로그인이 불가합니다."],
    autoLogin: false,

    isFail: false,
    failCount: 0,
  }),
  components: {},
  mounted() {
    LogRocket.init("bnb-platform-user/bnb-platform-user");

    if (localStorage.getItem("autoLogin") == "1") {
      this.isActive = true;
      this.input.courseAccesscode = localStorage.getItem("accessCode");
      this.input.userId = localStorage.getItem("userId");
      this.input.password = atob(localStorage.getItem("pass"));
      this.login();
    } else {
      this.input.courseAccesscode = "";
      this.input.userId = "";
      this.input.password = "";
    }

    this.inputSetting();
    fcmSetting();
  },
  methods: {
    inputSetting() {
      //안드로이드 모바일 IME keycode 229 이슈 해결용 이벤트 리스너
      let userIdInput = document.getElementById("userId");
      let accessCodeInput = document.getElementById("accessCode");
      userIdInput.addEventListener("input", (event) => {
        this.input.userId = event.target.value;
      });
      accessCodeInput.addEventListener("input", (event) => {
        this.input.courseAccesscode = event.target.value;
      });
    },

    check() {
      if (this.isActive) {
        localStorage.setItem("accessToken", null);
        if (!EmptyCheck(this.input.courseAccesscode, "기업코드를")) {
          this.isSuccess = 2;
          return false;
        }
        if (!EmptyCheck(this.input.userId, "아이디(이메일)을")) {
          this.isSuccess = 2;
          return false;
        }
        if (!EmailFormatCheck(this.input.userId)) {
          this.isSuccess = 2;
          return false;
        }
        let params = {
          courseAccesscode: this.input.courseAccesscode,
          userId: this.input.userId,
        };
        this.axios
          .post("/auth/user-login/code-check", params)
          .then((res) => {
            if (res.data.success) {
              //로그로캣 유저 인증
              LogRocket.identify(this.input.userId, {
                name: this.input.userId,
                email: this.input.userId,
                subscriptionType: "pro",
              });
              console.log(123123);

              if (this.loginErrMessage.indexOf(res.data.message) != -1) {
                alert(res.data.message);
                return false;
              }

              let userInfo = {
                accessCode: this.input.courseAccesscode,
                userId: this.input.userId,
                pass: this.input.password,
                courseIdx: res.data.contentinfo.courseIdx,
                courseCategoryLimit: res.data.contentinfo.courseCategoryLimit,
                courseEmbeddedSurvey: res.data.contentinfo.courseEmbeddedSurvey,
                coarchingYN: res.data.contentinfo.coarchingYN,
                embeddedSurveyYN: res.data.contentinfo.embeddedSurveyYN,
                userSurveyYN: res.data.contentinfo.userSurveyYN,
              };
              // userInfo.coarching =
              this.$store.commit("setCourseInfo", userInfo);

              if (!res.data.contentinfo.isFirstLogin) {
                // if(res.data.contentinfo.embeddedSurveyYN == "N" &&  res.data.contentinfo.coarchingYN == "N"){
                //     this.$router.push('embedded_survey');
                // }else if(res.data.contentinfo.embeddedSurveyYN == "Y" &&  res.data.contentinfo.coarchingYN == "N"){
                //     this.$router.push({name:"coach_recom",params:{rebook:0}})
                // }else{
                //     this.isSuccess = 1;
                // }
                this.isSuccess = 1;
              } else {
                localStorage.setItem("isEmbedded", null);
                localStorage.setItem("mainSurveyData", null);
                localStorage.setItem("mainSurveyClearDate", null);
                localStorage.setItem("subSurveyData", null);
                this.$router.push({ name: "join" });
              }
            } else {
              alert(res.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    passwordAcount() {
      this.$router.push({ name: "password_account", params: { isAccount: 0 } });
    },
    keyupEvent() {
      console.log(this.input);
      if (this.input.userId != "" && this.input.courseAccesscode != "") {
        this.isActive = true;
      }
    },
    login() {
      // console.log(this.autoLogin);
      if (!EmptyCheck(this.input.password, "비밀번호를")) {
        this.isPassword = false;
        return false;
      } else {
        this.isPassword = true;
      }
      // console.log(this.input);
      let params = this.input;
      params.deviceId = localStorage.getItem("fcmtoken");
      this.autoLogin = localStorage.getItem("autoLogin");
      this.axios
        .post("/auth/user-login", params)
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            localStorage.setItem("accessToken", res.data.contentinfo.access_token);
            let userInfo = {
              accessCode: this.$store.state.courseInfo.accessCode,
              userId: this.$store.state.courseInfo.userId,
              pass: this.$store.state.courseInfo.pass,
              courseIdx: this.$store.state.courseInfo.courseIdx,
              courseCategoryLimit: this.$store.state.courseInfo.courseCategoryLimit,
              courseEmbeddedSurvey: this.$store.state.courseInfo.courseEmbeddedSurvey,
              userIdx: res.data.contentinfo.userInfo.userIdx,
              userName: res.data.contentinfo.userInfo.username,
              coarching: res.data.contentinfo.coarchingList,
              appProgress: res.data.contentinfo.appProgress,
            };
            if (this.autoLogin) {
              localStorage.setItem("autoLogin", "1");
              localStorage.setItem("accessCode", this.input.courseAccesscode);
              localStorage.setItem("userId", this.input.userId);
              localStorage.setItem("pass", btoa(this.input.password));
            } else {
              localStorage.setItem("autoLogin", "0");
            }
            this.$store.commit("setUserInfo", userInfo);
            this.$store.commit("setUserIdx", res.data.contentinfo.userInfo.userIdx);
            this.pagePush(userInfo);
          } else {
            this.isPassword = false;
            this.failCount = res.data.userPasswordFailureCount;
            if (this.failCount >= 5) {
              alert("비밀번호 연속 5회 실패하였습니다.");
              // this.$router.push({
              //   name: "password_account",
              //   params: { isAccount: 1 },
              // });
            }
            this.isFail = true;
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
      localStorage.setItem("userId", this.input.userId);
    },
    pagePush(userInfo) {
      if (this.$store.state.courseInfo.courseCategoryLimit == "1" || this.$store.state.courseInfo.courseCategoryLimit == "N") {
        //카테고리 제한 없음 과정
        if (this.$store.state.courseInfo.courseEmbeddedSurvey == "Y") {
          if (userInfo.appProgress == "EMBED_SURVEY_BEGIN") {
            //임베디드 서베이 대분류,소분류 작성 전
            localStorage.setItem("mainSurveyData", "");
            localStorage.setItem("subSurveyData", "");
            localStorage.setItem("isEmbedded", "0");
            this.$router.push("embedded_survey");
          } else if (userInfo.appProgress == "EMBED_SURVEY_STEP2") {
            //임베디드 서베이 대분류 작성, 소분류 작성 전
            localStorage.setItem("subSurveyData", "");
            localStorage.setItem("isEmbedded", "0");
            this.$router.push("embedded_survey_subject");
          } else if (userInfo.appProgress == "CHOICE_SUBJECT") {
            //임베디드 서베이 대분류 작성, 소분류 작성, 주제 선택 전
            this.$router.push({
              name: "reserve_subject",
              params: { rebook: 0 },
            });
          } else if (userInfo.appProgress == "CHOICE_COACH") {
            //임베디드 서베이 대분류 작성, 소분류 작성, 주제 선택, 코칭 예약 전
            this.$router.push({ name: "coach_recom", params: { rebook: 0 } });
          } else {
            this.$router.push({ name: "home" });
            receivedNotifcation();
          }
        } else {
          //임베디드 미사용 과정
          if (userInfo.appProgress == "CHOICE_SUBJECT") {
            // 주제 선택 전
            this.$router.push({
              name: "reserve_subject_sub",
              params: { rebook: 0 },
            });
          } else if (userInfo.appProgress == "CHOICE_COACH") {
            //주제 선택 이후, 코칭 예약 전
            this.$router.push({ name: "coach_recom", params: { rebook: 0 } });
          } else {
            this.$router.push({ name: "home" });
            receivedNotifcation();
          }
        }
      } else {
        //카테고리 제한 과정
        if (userInfo.appProgress == "CHOICE_SUBJECT") {
          // 주제 선택 전
          this.$router.push({
            name: "reserve_subject_sub",
            params: { rebook: 0 },
          });
        } else if (userInfo.appProgress == "CHOICE_COACH") {
          //주제 선택 이후, 코칭 예약 전
          this.$router.push({ name: "coach_recom", params: { rebook: 0 } });
        } else {
          this.$router.push({ name: "home" });
          receivedNotifcation();
        }
      }
    },
  },
};
</script>
